(() => {
  'use strict';

  function initHeroSlider(root) {
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;

    const prevBtn = root.querySelector('[data-hero-prev]');
    const nextBtn = root.querySelector('[data-hero-next]');
    const currentLabel = root.querySelector('[data-hero-current]');
    const autoplayMs = Number(root.dataset.autoplayMs) || 6500;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = slides.findIndex((s) => s.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function goTo(next) {
      if (next === index) return;
      const prevSlide = slides[index];
      const nextSlide = slides[next];

      prevSlide.classList.remove('is-active');
      prevSlide.setAttribute('inert', '');
      prevSlide.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));

      nextSlide.classList.add('is-active');
      nextSlide.removeAttribute('inert');
      nextSlide.querySelectorAll('a').forEach((a) => a.removeAttribute('tabindex'));

      index = next;
      if (currentLabel) currentLabel.textContent = pad(index + 1);
    }

    function next() {
      goTo((index + 1) % slides.length);
    }

    function prev() {
      goTo((index - 1 + slides.length) % slides.length);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (reducedMotion || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, autoplayMs);
    }

    prevBtn?.addEventListener('click', () => {
      prev();
      startAutoplay();
    });

    nextBtn?.addEventListener('click', () => {
      next();
      startAutoplay();
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        (document.documentElement.dir === 'rtl' ? prev : next)();
        startAutoplay();
      } else if (event.key === 'ArrowLeft') {
        (document.documentElement.dir === 'rtl' ? next : prev)();
        startAutoplay();
      }
    });

    // Touch swipe — no library, plain pointer events.
    let pointerStartX = null;
    root.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch') return;
      pointerStartX = event.clientX;
    });
    root.addEventListener('pointerup', (event) => {
      if (pointerStartX === null || event.pointerType !== 'touch') return;
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 40) return;
      const isRtl = document.documentElement.dir === 'rtl';
      if (delta < 0) {
        (isRtl ? prev : next)();
      } else {
        (isRtl ? next : prev)();
      }
      startAutoplay();
    });

    startAutoplay();
  }

  document.querySelectorAll('[data-soulo-hero-slider]').forEach(initHeroSlider);
})();
